<template>
  <div class="custom-input">
    <v-menu v-model="open" offset-y :close-on-content-click="false" :disabled="disabled || readonly">
      <template v-slot:activator="{ on, attrs }">
        <v-text-field
          type="text"
          :label="$t(label)"
          :placeholder="$t(placeholder)"
          outlined
          color="primary accent-4"
          :dense="dense"
          :disabled="disabled"
          :hide-details="hideDetails"
          :class="inputClass"
          autocomplete="new-password"
          persistent-placeholder
          :rules="rules"
          :value="inputDisplayValue"
          v-bind="attrs"
          v-on="on"
          readonly
        />
      </template>

      <v-container fluid style="background: #ffffff;">
        <v-text-field
          v-model="searchText"
          clearable
          dense
          hide-details
          :rules="searchTextRules"
          :placeholder="$t(searchPlaceholder)"
          @click:clear="inputSearch('')"
          :append-icon="icon.mdiMagnify"
          @click:append="inputSearch(searchText)"
          @keydown.enter="inputSearch(searchText)"
        ></v-text-field>
        <v-progress-linear v-if="searching" indeterminate color="primary" />
        <v-list class="mt-2" style="max-height: 50vh; overflow-x: hidden; overflow-y: auto;">
          <v-list-item v-show="!options || options.length < 1">
            <v-list-item-title>{{ $t('table.noData') }}</v-list-item-title>
          </v-list-item>

          <v-list-item v-for="(item, index) in options" :key="index" @click="onSearchResultClick(item.value)">
            <v-list-item-title>{{ item.text }}</v-list-item-title>
          </v-list-item>
        </v-list>
      </v-container>
    </v-menu>
  </div>
</template>

<script>
import { mdiMagnify } from '@mdi/js'
export default {
  name: 'FormSearchSelect',
  props: {
    searching: {
      type: Boolean,
      default: false,
      required: false,
    },
    label: {
      type: String,
      required: false,
      default: '',
    },
    fieldValue: {
      type: String | Number,
      required: true,
      default: '',
    },
    hideDetails: {
      type: Boolean,
      required: false,
      default: false,
    },
    required: {
      type: Boolean,
      required: false,
      default: false,
    },
    readonly: {
      type: Boolean,
      required: false,
      default: false,
    },
    placeholder: {
      type: String,
      required: false,
      default: '',
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false,
    },
    dense: {
      type: Boolean,
      required: false,
      default: false,
    },
    customInputClass: {
      type: String,
      required: false,
      default: '',
    },
    dispatchUpdateOnChange: {
      type: Boolean,
      required: false,
      default: false,
    },
    searchTextRules: {
      type: Array,
      default: () => [],
    },
    searchPlaceholder: {
      type: String,
      required: false,
      default: 'search',
    },
    options: {
      type: Array,
      default: () => [],
      required: true,
    },
  },
  computed: {
    rules() {
      return [v => (this.required ? this.$validate.required(v) || this.$t('form.required') : true)]
    },
    inputClass() {
      let classObj = {
        'pointer-none': this.$store.getters.isLoading || this.disabled || this.readonly,
      }
      if (this.$validate.DataValid(this.customInputClass)) {
        const arr = this.customInputClass.split(' ')
        arr.forEach(name => {
          if (this.$validate.DataValid(name.trim())) {
            classObj[name.trim()] = true
          }
        })
      }

      return classObj
    },
  },
  data: () => ({
    open: false,
    icon: {
      mdiMagnify,
    },
    searchText: '',
    inputDisplayValue: '',
  }),
  methods: {
    inputSearch(value) {
      this.$emit('input-search', value)
    },

    onSearchResultClick(value) {
      const target = this.options.find(el => el.value === value)
      if (target) {
        this.inputDisplayValue = target.text
        this.$emit('update:fieldValue', value)
        this.$emit('onselect', value)
        this.open = false;
        if (this.dispatchUpdateOnChange === true) {
          this.$store.dispatch('setDataIsUpdated', true)
        }
      }
    },
  },
}
</script>
